import React, { FC, PropsWithChildren } from 'react'
import { useModal } from '@shared/lib'
import { useBreakpoint } from '@shared/lib/react'
import { TextButton } from '@shared/ui/atoms'
import OfferAgreementModalDesktop from './OfferAgreementModalDesktop'
import OfferAgreementModalMobile from './OfferAgreementModalMobile'

const OfferAgreementButton: FC<PropsWithChildren> = ({ children }) => {
  const { isModalActive, handleModalClose, handleModalOpen } = useModal()

  const { isMobile } = useBreakpoint()

  return (
    <>
      <TextButton onClick={handleModalOpen}>{children}</TextButton>
      {isMobile ? (
        <OfferAgreementModalMobile open={isModalActive} onClose={handleModalClose} />
      ) : (
        <OfferAgreementModalDesktop open={isModalActive} onClose={handleModalClose} />
      )}
    </>
  )
}

export default OfferAgreementButton
